import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const RoundedTriangleIcon = (props: IconProps) => (
  <Icon width="12px" height="12px" viewBox="0 0 12 12" {...props}>
    <path d="M5.13399 1.5C5.51889 0.833333 6.48114 0.833333 6.86604 1.5L11.1962 9C11.5811 9.66667 11.0999 10.5 10.3301 10.5H1.66989C0.900087 10.5 0.418962 9.66667 0.803862 9L5.13399 1.5Z" />
  </Icon>
);

export default memo(RoundedTriangleIcon);
